__turbopack_context__.v({
  "arrow": "StrapSelector-module-scss-module__AnJu5W__arrow",
  "arrowHidden": "StrapSelector-module-scss-module__AnJu5W__arrowHidden",
  "arrowNext": "StrapSelector-module-scss-module__AnJu5W__arrowNext",
  "arrowPrev": "StrapSelector-module-scss-module__AnJu5W__arrowPrev",
  "carousel": "StrapSelector-module-scss-module__AnJu5W__carousel",
  "colorBlock": "StrapSelector-module-scss-module__AnJu5W__colorBlock",
  "colorButton": "StrapSelector-module-scss-module__AnJu5W__colorButton",
  "colorButtonSelected": "StrapSelector-module-scss-module__AnJu5W__colorButtonSelected",
  "colorImage": "StrapSelector-module-scss-module__AnJu5W__colorImage",
  "colorImageLoaded": "StrapSelector-module-scss-module__AnJu5W__colorImageLoaded",
  "colorImageLoading": "StrapSelector-module-scss-module__AnJu5W__colorImageLoading",
  "colorImageSpinner": "StrapSelector-module-scss-module__AnJu5W__colorImageSpinner",
  "colorImageWrap": "StrapSelector-module-scss-module__AnJu5W__colorImageWrap",
  "colorItem": "StrapSelector-module-scss-module__AnJu5W__colorItem",
  "colorLabel": "StrapSelector-module-scss-module__AnJu5W__colorLabel",
  "colorName": "StrapSelector-module-scss-module__AnJu5W__colorName",
  "dot": "StrapSelector-module-scss-module__AnJu5W__dot",
  "dotActive": "StrapSelector-module-scss-module__AnJu5W__dotActive",
  "dots": "StrapSelector-module-scss-module__AnJu5W__dots",
  "heading": "StrapSelector-module-scss-module__AnJu5W__heading",
  "material": "StrapSelector-module-scss-module__AnJu5W__material",
  "materialLabel": "StrapSelector-module-scss-module__AnJu5W__materialLabel",
  "materialSelected": "StrapSelector-module-scss-module__AnJu5W__materialSelected",
  "materials": "StrapSelector-module-scss-module__AnJu5W__materials",
  "root": "StrapSelector-module-scss-module__AnJu5W__root",
  "strap-selector-spin": "StrapSelector-module-scss-module__AnJu5W__strap-selector-spin",
  "swatch": "StrapSelector-module-scss-module__AnJu5W__swatch",
  "track": "StrapSelector-module-scss-module__AnJu5W__track",
  "trackCentered": "StrapSelector-module-scss-module__AnJu5W__trackCentered",
  "viewport": "StrapSelector-module-scss-module__AnJu5W__viewport",
});
